import { FormControlLabel, Radio } from '@mui/material';
import { styled } from '@mui/system';

export const StyledFormControlLabel = styled(FormControlLabel)(({ theme }) => ({
  '& .MuiFormControlLabel-label': {
    color: theme.palette.text.primary,
    fontSize: 14,
    fontWeight: 500,
    lineHeight: '16px',
    latterSpacing: '-3%',
    marginLeft: 8,
  },
  '&:hover': {
    backgroundColor: theme.palette.text.main,
  },
}));

export const StyledRadio = styled(Radio)(({ theme }) => ({
  '&.Mui-checked': {
    color: theme.palette.primary.main,
  },
}));